<template>
  <div>
    <div v-if="model.length > 0">
      <div v-for="(item, index) in companyExemptions" :key="index" class="mb-2">
        <custom-callout :border-color="getColor(item.exemptionStatusId)">
          <div class="row">
            <div class="col-sm d-flex justify-content-center border-right">
              <div class="w-80">
                <custom-balloon
                  :background-color="getColor(item.exemptionStatusId)"
                  class="mt-2 p-2 font-weight-normal font-16"
                  :text="item.exemptionStatusName"
                />
              </div>
            </div>
            <div class="col-sm">
              <span class="data-name">Fecha Sometida:</span>
              <p class="data">{{ $formatDate(item.createdDate) }}</p>
            </div>
            <div class="col-sm">
              <span class="data-name">Fecha Desde:</span>
              <p class="data">{{ $formatDate(item.exemptionStartDate) }}</p>
            </div>
            <div class="col-sm">
              <span class="data-name">Fecha Hasta:</span>
              <p class="data">{{ $formatDate(item.exemptionEndDate) }}</p>
            </div>
            <div class="col-sm-2 text-center">
              <span class="data-name">Compañía</span>
              <p class="data">{{ item.companyName }}</p>
            </div>
            <div v-if="isDEPR" class="col-sm text-center">
              <span class="data-name">Número de Dispensa:</span>
              <p class="data">{{ item.exemptionDprNumber }}</p>
            </div>
            <div v-else class="col-sm text-center">
              <span class="data-name">Total Supervisados:</span>
              <p class="data">{{ item.supervisedTotal }}</p>
            </div>
            <div class="col-sm d-flex h-100 justify-content-center">
              <action-button
                class="w-80"
                i="fas fa-file-search"
                text="Ver Detalles"
                variant="outline-success"
                @click="seeDetail(item)"
              />
            </div>
          </div>
        </custom-callout>
      </div>

      <custom-collapse id="ip-collapse">
        <custom-collapse-item
          body-background-color="#F7F7F7"
          :checked="true"
          class="px-4 mt-4"
          :expanded="false"
          parent-id="ip-collapse"
          title="Dispensas de otras corporaciones"
        >
          <div
            v-for="(item, index) in otherCompaniesExemptions"
            :key="index"
            class="mb-2"
          >
            <custom-callout :border-color="getColor(item.exemptionStatusId)">
              <div class="row">
                <div class="col-sm d-flex justify-content-center border-right">
                  <div class="w-80">
                    <custom-balloon
                      :background-color="getColor(item.exemptionStatusId)"
                      class="mt-2 p-2 font-weight-normal font-16"
                      :text="item.exemptionStatusName"
                    />
                  </div>
                </div>
                <div class="col-sm">
                  <span class="data-name">Fecha Sometida:</span>
                  <p class="data">{{ $formatDate(item.createdDate) }}</p>
                </div>
                <div class="col-sm">
                  <span class="data-name">Fecha Desde:</span>
                  <p class="data">{{ $formatDate(item.exemptionStartDate) }}</p>
                </div>
                <div class="col-sm">
                  <span class="data-name">Fecha Hasta:</span>
                  <p class="data">{{ $formatDate(item.exemptionEndDate) }}</p>
                </div>
                <div class="col-sm-2 text-center">
                  <span class="data-name">Compañía</span>
                  <p class="data">{{ item.companyName }}</p>
                </div>
                <div v-if="isDEPR" class="col-sm text-center">
                  <span class="data-name">Número de Dispensa:</span>
                  <p class="data">{{ item.exemptionDprNumber }}</p>
                </div>
                <div v-else class="col-sm text-center">
                  <span class="data-name">Total Supervisados:</span>
                  <p class="data">{{ item.supervisedTotal }}</p>
                </div>
                <div class="col-sm d-flex h-100 justify-content-center">
                  <action-button
                    class="w-80"
                    i="fas fa-file-search"
                    text="Ver Detalles"
                    variant="outline-success"
                    @click="seeDetail(item)"
                  />
                </div>
              </div>
            </custom-callout>
          </div>
        </custom-collapse-item>
      </custom-collapse>
    </div>
    <div v-else>
      <div class="col-12 p-4 text-center align-items-center no-info mt-4">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-1 align-self-center">
            <i class="far fa-folder-open icon no-info-icon pl-2" />
          </div>
          <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
            <span class="no-info-text">
              El especialista no cuenta con Dispensas.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import CustomBalloon from '@/components/common/CustomBalloon';
import alert from '@/mixins/alert.mixin';
import { getSpecialistExcemptions as _getSpecialistExcemptions } from '@/modules/provider/api.js';
import { getStatusColor } from '@/utils/constants/exemptionStatus.js';
import { CustomCollapse, CustomCollapseItem } from 'custom-collapse';

const DISPENSATION_REQUEST_PAGE = 'dispensation-request';

export default {
  name: '',
  components: {
    CustomCallout,
    CustomBalloon,
    CustomCollapse,
    CustomCollapseItem,
  },
  mixins: [alert],
  props: {
    companyId: {
      type: [String, Number],
      required: true,
      default: () => 0,
    },
    specialistId: {
      type: [String, Number],
      required: true,
    },
    isDEPR: {
      type: Boolean,
      required: false,
    },
    externalModel: { type: [Array, Boolean], default: false },
  },
  data() {
    return {
      model: [],
    };
  },
  computed: {
    companyExemptions() {
      return this.model.filter((x) => x.companyId == this.companyId);
    },
    otherCompaniesExemptions() {
      return this.model.filter((x) => x.companyId != this.companyId);
    },
    getColor() {
      return (statusId) => {
        return getStatusColor(statusId);
      };
    },
  },
  watch: {
    externalModel: {
      handler(value) {
        this.model = value;
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    if (typeof this.externalModel === 'boolean' && !this.externalModel) {
      await this.getSpecialistExcemptions();
    }
  },
  methods: {
    async getSpecialistExcemptions() {
      var self = this;
      _getSpecialistExcemptions(self.specialistId, self.companyId)
        .then((response) => {
          self.model = response.data;
        })
        .catch(() =>
          self.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          )
        );
    },
    seeDetail(record) {
      this.$router.push({
        name: DISPENSATION_REQUEST_PAGE,
        params: {
          dispensationRequestId: record.exemptionRequestId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
  .no-info-text {
    text-align: left;
    font: Bold 16px/22px Lato;
    letter-spacing: 0;
    color: #727272;
    opacity: 1;
  }
  .no-info-icon {
    color: #727272;
    font-size: 32px;
  }
}
</style>
